const push = (
  item:
    | GtagSearchEvent
    | GtagPaymentEvent
    | GtagTicketEvent
    | GtagExploreEvent
    | GtagAppDownEvent
    | GtagFABEvent
    | GtagBannerClickEvent
    | GtagAirportEvent
) => {
  if (window.dataLayer) {
    try {
      window.dataLayer.push(item)
    } catch (err) {
      console.log(err)
    }
  }
}

export default push
